import React from 'react';
import { useSelector } from 'react-redux';

import { ListingHelmet } from 'ha/modules/ListingHelmet';

import {
  getListingEntity,
  getPreviewImage,
  getListingImages,
  getIsImperialSystem,
} from '../../selectors';

const ListingHelmetContainer: React.FC = () => {
  const listing = useSelector(getListingEntity);
  const mainPhoto = useSelector(getPreviewImage) || '';
  const isImperialSystem = useSelector(getIsImperialSystem);
  const images = useSelector(getListingImages);

  return (
    <ListingHelmet
      mainPhoto={mainPhoto}
      listing={listing}
      images={images}
      isImperialSystem={isImperialSystem}
    />
  );
};

export { ListingHelmetContainer };
